import { useRef } from "react";
import BrainIcon from "../assets/icons/brain.svg?react";
import MedallionIcon from "../assets/icons/medallion.svg?react";
import ValuesIcon from "../assets/icons/values.svg?react";
// eslint-disable-next-line no-unused-vars
import { useInView, motion } from "framer-motion";

const ChooseUsPage = ({ id }) => {

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  return (
    <section
      id={id}
      className="h-full py-5 lg:py-0 lg:h-screen bg-gradient-to-b from-midnight-blue to-midnight flex flex-col justify-center items-center w-full gap-5"
    >
      <p className="text-white pt-4 xs:pt-0 text-lg xs:text-2xl md:text-4xl font-medium text-center ">
        Technology, Vision, and Impact
      </p>
      <div className="w-full flex flex-col lg:flex-row ">
        <div className="flex flex-col self-center lg:gap-2 w-full md:w-7/8 lg:w-3/4 lg:h-7/8 lg:ml-10 lg:-mr-10 lg:pt-3">
          <motion.div
            className="bg-inherit hover:bg-gray-200 hover:text-midnight text-gray-200 shadow-md grid grid-cols-[0.5fr_4fr] transition-colors duration-300 p-3"
            ref={ref}
            initial={{ opacity: 0, x: -100 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
            transition={{ duration: 0.8, ease: "linear" }}
          >
            <div className="flex justify-start sm:justify-center  items-start pt-3">
              <BrainIcon className="w-6 xs:w-8 sm:w-10 text-inherit" />
            </div>
            <div className="w-full sm:w-7/8 py-2">
              <p className="text-inherit font-semibold text-justify text-sm sm:text-lg text-wrap">
                Mission
              </p>
              <p className="text-inherit text-xs sm:text-sm text-justify">
                Our mission is to leverage technology and innovation to create
                impactful solutions, invest strategically, and transform
                visionary ideas into products that enhance how people live,
                work, and interact.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="bg-inherit hover:bg-gray-200 hover:text-midnight text-gray-200 shadow-md grid grid-cols-[0.5fr_4fr] p-3 transition-colors duration-300"
            ref={ref}
            initial={{ opacity: 0, x: -100 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
            transition={{ duration: 0.8, ease: "linear" }}
          >
            <div className="flex justify-start sm:justify-center items-start pt-3">
              <MedallionIcon className="w-6 xs:w-8 sm:w-10 text-inherit" />
            </div>
            <div className="w-full sm:w-7/8 py-2">
              <p className="text-inherit font-semibold text-justify text-sm sm:text-lg text-wrap">
                Vision
              </p>
              <p className="text-inherit text-xs sm:text-sm text-justify">
                Our vision is to lead in technological innovation and
                sustainable development, driving progress through investments,
                partnerships, and impactful products to shape a smarter, more
                connected future.
              </p>
            </div>
          </motion.div>

          <motion.div
            className="bg-inherit hover:bg-gray-200 hover:text-midnight text-gray-200 shadow-md grid grid-cols-[0.5fr_4fr] p-3 transition-colors duration-300"
            ref={ref}
            initial={{ opacity: 0, x: -100 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
            transition={{ duration: 0.8, ease: "linear" }}
          >
            <div className="flex justify-start sm:justify-center items-start pt-3">
              <ValuesIcon className="w-6 xs:w-8 sm:w-10 text-inherit" />
            </div>
            <div className="w-full sm:w-7/8 py-2">
              <p className="text-inherit font-semibold text-justify text-sm sm:text-lg text-wrap">
                Values and Corporate Culture
              </p>
              <p className="text-inherit text-xs sm:text-sm text-justify">
                Our culture is built on continuous learning, adaptability, and
                resilience. We foster open-minded innovation, teamwork, and a
                commitment to creating lasting value for society and businesses.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="flex justify-end self-center w-3/4 h-full md:w-3/5 lg:h-7/8 lg:w-3/4 pt-7 pb-2 lg:p-0">
          <img
            src="/choose-img1.webp"
            alt="Choose image 1"
            className="h-full rounded-r-xl lg:rounded-r-none"
          />
        </div>
      </div>
    </section>
  );
};

export default ChooseUsPage;
